import React from "react";
import { motion } from "framer-motion";
import { LandPlot, Building2, Landmark, LineChart } from "lucide-react";

const ITEMS = [
  {
    icon: LandPlot,
    title: "Landowners",
    text: "Organize and understand infrastructure lease assets.",
  },
  {
    icon: Building2,
    title: "Building Owners",
    text: "Track rooftop agreements and infrastructure opportunities.",
  },
  {
    icon: Landmark,
    title: "Municipalities",
    text: "Modernize infrastructure visibility and organization.",
  },
  {
    icon: LineChart,
    title: "Investors",
    text: "Access curated infrastructure participation opportunities.",
  },
];

export default function WhoWeServe() {
  return (
    <section
      id="who-we-serve"
      className="relative mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-28"
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
        className="mb-14 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end"
      >
        <div>
          <p className="mb-3 font-display text-[12px] font-extrabold uppercase tracking-[0.18em] text-[#38BDF8]">
            Who InfraYield Serves
          </p>
          <h2 className="font-display text-3xl font-bold leading-[1.05] tracking-[-0.04em] text-[#F8FAFC] sm:text-5xl">
            Built for every side
            <br className="hidden sm:block" /> of infrastructure ownership.
          </h2>
        </div>
        <p className="max-w-sm font-body text-base leading-[1.7] text-[#94A3B8]">
          A purpose-built operating layer for the people who own, regulate, and
          invest in the infrastructure behind modern life.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((it, i) => (
          <motion.article
            key={it.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.55, delay: i * 0.07 }}
            className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#1E293B] bg-[#0F1B2D] p-7 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#38BDF8]/40"
            data-testid={`serves-card-${i}`}
          >
            <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-lg border border-[#1E293B] bg-[#07111F] text-[#22C55E]">
              <it.icon className="h-5 w-5" />
            </div>
            <h3 className="font-display text-xl font-semibold text-[#F8FAFC]">
              {it.title}
            </h3>
            <p className="mt-3 font-body text-[15px] leading-relaxed text-[#94A3B8]">
              {it.text}
            </p>
            <span className="absolute right-5 top-5 font-display text-xs font-medium text-[#334155]">
              0{i + 1}
            </span>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
